import { conditionFormChecker, putField } from "../../../../utils/form";
import { createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import {
    createFieldCheckbox,
    createFieldInput, createFieldRadioGroup,
    createFieldSelect, createFieldTemplateBuilder
} from "../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";

export const callTypeByGroup = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SUB_STANCE_TYPE", value: searchQuery });
export const callSpeciesByGroup = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SPECIES", value: searchQuery });
export const callDofControlByGroup = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_DOF_CONTROL", value: searchQuery });
export const callSubObjectByGroup = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_SUB_OBJECT", value: searchQuery })
        .then(items => items.filter(item => !["3"].includes(item.key)));

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.hazSubStance.refType"),
            dataIndex: "refType.id",
            customRender: ({ record }) => <div>{record.refType?.value}</div>,
            inputProp: () => ({ list: callTypeByGroup, optLabel: "value" }),
            align: "center",
            width: 120
        }),
        createColumnInput({ title: () => i18n.global.t("model.hazSubStance.modelName"), dataIndex: "name", width: 300 }),
        createColumnInput({ title: () => i18n.global.t("model.hazSubStance.nameEn"), dataIndex: "nameEn", width: 200 }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazSubStance.refSpecies"),
            dataIndex: "refSpecies.id",
            customRender: ({ record }) => <div>{record.refSpecies?.value}</div>,
            inputProp: () => ({ list: callSpeciesByGroup, optLabel: "value" }),
            align: "center",
            width: 120
        }),
        createColumnInput({ title: () => i18n.global.t("model.hazSubStance.casNo"), dataIndex: "casNo", align: "center", width: 120 }),
        createColumnInput({ title: () => i18n.global.t("model.hazSubStance.ecNo"), dataIndex: "ecNo", align: "center", width: 120 }),
        createColumnInput({ title: () => i18n.global.t("model.hazSubStance.indexNo"), dataIndex: "indexNo", align: "center", width: 120 }),
    ]
    return columns
}

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazSubStance.refType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refType,
                            "onUpdate:value": value => (model.refType = value),
                            disabled: viewOnly,
                            list: callTypeByGroup,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSpecies`,
                colProp: () => ({ xs: 24, md: 12}),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazSubStance.refSpecies"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSpecies,
                            "onUpdate:value": value => (model.refSpecies = value),
                            disabled: viewOnly,
                            list: callSpeciesByGroup,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}name`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazSubStance.name")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.name,
                            "onUpdate:value": value => (model.name = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}casNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazSubStance.casNo")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.casNo,
                            "onUpdate:value": value => (model.casNo = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}nameEn`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazSubStance.nameEn")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.nameEn,
                            "onUpdate:value": value => (model.nameEn = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}ecNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazSubStance.ecNo")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ecNo,
                            "onUpdate:value": value => (model.ecNo = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSubObjective`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazSubStance.refSubObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSubObjective,
                            "onUpdate:value": value => model.refSubObjective = value,
                            disabled: viewOnly,
                            list: callSubObjectByGroup,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}indexNo`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazSubStance.indexNo")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.indexNo,
                            "onUpdate:value": value => (model.indexNo = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTemplateBuilder({
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t('model.hazSubStance.structure'),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({
                        data, fields: [
                            createFieldCheckbox({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                key: 'isSolid',
                                colProp: () => ({ xs: 24, md: 2 }),
                                label: () => `${i18n.global.t("model.haz.isSolid")}`,
                                labelRender: () => "",
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            checked: modelRef.isSolid, 'onUpdate:checked': checked => modelRef.isSolid = checked, disabled: viewOnly
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    )
                            }),
                            createFieldInput({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                key: `${prefix}solid`,
                                colProp: () => ({ xs: 24, md: 22 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                                label: () => `${i18n.global.t("model.haz.solid")}`,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.solid,
                                            "onUpdate:value": value => (model.solid = value),
                                            disabled: viewOnly
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    )
                            }),
                            createFieldCheckbox({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                key: 'isLiquid',
                                colProp: () => ({ xs: 24, md: 2 }),
                                label: () => `${i18n.global.t("model.haz.isLiquid")}`,
                                labelRender: () => "",
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            checked: modelRef.isLiquid, 'onUpdate:checked': checked => modelRef.isLiquid = checked, disabled: viewOnly
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    )
                            }),
                            createFieldInput({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                                key: `${prefix}liquid`,
                                colProp: () => ({ xs: 24, md: 22 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                                label: () => `${i18n.global.t("model.haz.liquid")}`,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.liquid,
                                            "onUpdate:value": value => (model.liquid = value),
                                            disabled: viewOnly
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    )
                            }),
                        ]
                    })
                })
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDofControl`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazSubStance.refDofControl"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDofControl,
                            "onUpdate:value": value => model.refDofControl = value,
                            disabled: viewOnly,
                            list: callDofControlByGroup,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
        ]
    });
};